import { baseApi } from '../base'

export const userSettingsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getUserSettings: build.query({
      query: () => `/user-settings`,
      providesTags: () => [{ type: 'UserSettings', id: 'ALL' }],
    }),

    saveUserSettings: build.mutation({
      query: ({ key, value }) => ({
        url: `/user-settings`,
        method: 'POST',
        body: { key, value },
      }),
      invalidatesTags: () => [{ type: 'UserSettings', id: 'ALL' }],
    }),
  }),
  overrideExisting: false,
})

export const { useGetUserSettingsQuery, useSaveUserSettingsMutation } =
  userSettingsApi
